import { ComponentType } from "react";
import {
  ButtonSlotProps,
  DocumentUploadModalMode,
  DocumentUploadModalNavigationDirection,
} from "../types";

import styles from "./close-confirmation-view.module.scss";

type CloseConfirmationViewProps = {
  onCancel: () => void;
  onConfirm: () => void;
  navigationDirection: DocumentUploadModalNavigationDirection;
  mode: DocumentUploadModalMode;
  Button: ComponentType<ButtonSlotProps>;
};

export const CloseConfirmationView = ({
  onCancel,
  onConfirm,
  navigationDirection,
  mode,
  Button,
}: CloseConfirmationViewProps) => (
  <>
    <h2
      className={styles.heading}
    >{`Are you sure you want to ${navigationDirection === DocumentUploadModalNavigationDirection.BACK ? "go back" : "exit"}?`}</h2>
    <p className={styles.description}>Your changes will not be saved</p>
    <div className={styles.actionsContainer}>
      <Button
        onClick={onConfirm}
        variant="primary"
        size="small"
        tone="destructive"
        isFullWidth
      >
        {`${navigationDirection === DocumentUploadModalNavigationDirection.CLOSE ? "Exit" : "Go back"} - changes will be lost`}
      </Button>
      <Button onClick={onCancel} variant="secondary" size="small" isFullWidth>
        {`Continue ${mode === DocumentUploadModalMode.ADD ? "adding" : "editing"} document`}
      </Button>
    </div>
  </>
);
